import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import { v4 as uuid } from 'uuid'

import { Loader } from '@/components/loaders/Loader'
import { AgentRow } from '@/components/cards/AgentRow'
import { SegmentedControl } from '@/components/buttons/SegmentedControl'

const NEGATIVE_TAB = 'bottom_calls'
const POSITIVE_TAB = 'top_calls'

export const SentimentList = ({ loading, sentiment }) => {
  const [activeTab, setActiveTab] = useState(NEGATIVE_TAB)

  const descriptionLoading =
    (activeTab === NEGATIVE_TAB && loading.sentimentUpsetReasons) ||
    (activeTab === POSITIVE_TAB && loading.sentimentPositiveReasons)

  const tabItems = [
    {
      accessor: NEGATIVE_TAB,
      label: 'Negative Calls',
      active: activeTab === NEGATIVE_TAB,
      onClick: () => setActiveTab(NEGATIVE_TAB),
    },
    {
      accessor: POSITIVE_TAB,
      label: 'Positive Calls',
      active: activeTab === POSITIVE_TAB,
      onClick: () => setActiveTab(POSITIVE_TAB),
    },
  ]

  return (
    <div data-testid="sentiment-list-container">
      {loading.sentiment ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : (
        !isEmpty(sentiment) && (
          <>
            <SegmentedControl className="mb" items={tabItems} />
            {!isEmpty(sentiment[activeTab]) ? (
              sentiment[activeTab].map((data, index) => {
                const agentFullName = `${data.agent_first_name} ${data.agent_last_name}`

                return (
                  <AgentRow
                    key={uuid()}
                    agentFullName={agentFullName}
                    description={
                      activeTab === NEGATIVE_TAB ? data.upset_reason : data.positive_reason
                    }
                    descriptionLoading={descriptionLoading}
                    index={index}
                    externalLink={{
                      label: 'Explore Call',
                      url: `/calls/${data.call_id}`,
                      id: data.call_id,
                    }}
                  />
                )
              })
            ) : (
              <div className="no-data">No call data available</div>
            )}
          </>
        )
      )}
    </div>
  )
}
